import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class UnidadNegocioService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerUnidadNegocio(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query($entidad:unidad_negocioInputType){
          unidad_negocio {
            obtenerUnidadNegocio (entidad:$entidad){
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.unidad_negocio.obtenerUnidadNegocio;
            callback({ mensajes, respuesta });
        });
    }
}
UnidadNegocioService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UnidadNegocioService_Factory() { return new UnidadNegocioService(i0.ɵɵinject(i1.GraphQLClient)); }, token: UnidadNegocioService, providedIn: "root" });
